import { AfterViewInit,Component, Inject, Optional, OnInit,ViewChild } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { EvaluacionService } from '../../../services/evaluacion.service';
import {MatSnackBar} from '@angular/material/snack-bar';


@Component({
  selector: 'app-dialog-box-copiar',
  templateUrl: './dialog-box-copiar.component.html',
  styleUrls: ['./dialog-box-copiar.component.scss']
})
export class DialogBoxCopiarComponent {

  action: string;
  motivo:string;
  LOCAL_DATA: any;
  nombre:string;

  constructor(
    public dialog: MatDialog,
    public service: EvaluacionService,
    public dialogRef: MatDialogRef<DialogBoxCopiarComponent>,
    public translate: TranslateService,
    private _snackBar: MatSnackBar,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.action = data.action;
    this.LOCAL_DATA = data.obj;
    //Object.assign(this, { multi });
  }

  doAction(): void{

    if(this.action=="Versionar")
      this.service.versionar(this.LOCAL_DATA.id).pipe().subscribe(req => {
        this.openSnackBar("Se versionó la evaluación correctamente.","Cerrar");
        window.location.reload();
      },
      err => {
        this.openSnackBar("No se pudo versionar la evaluación, ocurrió un error.","Cerrar");
      });

    if(this.action=="Copiar")
      this.service.copiar(this.LOCAL_DATA.id,this.nombre).pipe().subscribe(req => {
        this.openSnackBar("Se copió la evaluación correctamente.","Cerrar");
        window.location.reload();
      },
      error => {
        //this.openSnackBar("No se pudo copiar la evaluación, ocurrió un error.","Cerrar");
        if(error!=null && error.error!=null && error.error.message.indexOf('org.hibernate.exception.ConstraintViolationException') !=-1){
          this.openSnackBar("Ya existe una evaluacion con el nombre: "+this.LOCAL_DATA.nombre,"Cerrar");
        }else{
          this.openSnackBar("No se pudo copiar la evaluacion, ocurrió un error.","Cerrar");
        }
      });

    //this.dialogRef.close({event: this.action,motivo:this.motivo});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 10000,
    });
  }

  ngOnInit(): void {


  }

}
